import GetEventdetailMarscomplete from "./GetEventMarsComplete.jsx/GetEventdetailMarscomplete"
import { FormProvider } from './FormContextMarsComplete'
import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { EVENT_VISIBLE_TO_USER } from './ApiDetails.js';
import EventDenied from "./GetEvent.jsx/EventDenied"

function GetDetailMarsCompleteAdmin() {
  const location = useLocation();
  var eventId = location.pathname.split("/")[2];
  var role = localStorage.getItem('role');

  const [eventIsVisible, setEventIsVisible] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [secuOK, setSecuOK] = useState(false);
  
  const getIsEventVisible = async (eventID) => {
        await axios.get(`${EVENT_VISIBLE_TO_USER}/${eventID}`)
          .then(response => {
              var data = response.data;
              if (data != null) {
                  setEventIsVisible(data===true);
                  setSecuOK(true);
              }
          })
          .catch(error => {
              console.error('Error reading event : ', error);
          });
  }

  useEffect(() => {
      if (isFirstLoad) {
          getIsEventVisible(eventId);
          setIsFirstLoad(false);
      }
 }, []);

  //const renderPage = () => {
  if (!secuOK) {
      return "";
  } else
  if (!eventIsVisible) {
      return (
        <FormProvider>
          <EventDenied />
        </FormProvider>
      )
  }
  else
  switch (role) {
    case 'Visit Requester':
    case 'Requester':
      return (
        <div>
          <Navigate to={`/getDetail/${eventId}`} replace />
        </div>
      )
    case 'MLTUser':
    case 'MLTCoordinator':
      return (
        <div>
          <Navigate to={`/GetDetailEventMlt/${eventId}`} replace />
        </div>
      )
    case 'Admin':
      return (
        <div>
          <Navigate to={`/GetDetailAdmin/${eventId}`} replace />
        </div>
      )
    case 'Family':
    case 'FamilyCoordinator':
      return (
        <FormProvider>
          <GetEventdetailMarscomplete />
        </FormProvider>
      )
    default:
      return (
        <div>
          <Navigate to="/" replace />
        </div>
      )
  }
}

export default GetDetailMarsCompleteAdmin;